// Below this width the bars drop to their compact buttons and panels dock inside the viewer.
export const NARROW_PX = 520;
// Below this width the grid readout gives way; the Grid toggle stays in the bottom bar.
export const GRID_READOUT_MIN_PX = 640;
// Below either, the bars no longer fit: the viewer keeps only its expand button, and the tools open with it.
export const MINI_WIDTH_PX = 360;
export const MINI_HEIGHT_PX = 240;
export const CHROME_INSET_PX = 12;
export const RENDER_MAX_EDGE_PX = 1536;
